import React, { createContext, useEffect, useState, useCallback, useMemo } from 'react';

const STORAGE_KEY = 'themeMode'; // also read by the blog, see frontend/blog/README.md

function getInitialMode() {
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export const ThemeModeContext = createContext(undefined);

export function ThemeModeProvider({ children }) {
  const [mode, setMode] = useState(getInitialMode);

  useEffect(() => {
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    // Only follow the OS setting until the user makes an explicit choice —
    // once themeMode is stored, that choice wins over future OS changes.
    const handleChange = (e) => {
      if (window.localStorage.getItem(STORAGE_KEY) === null) {
        setMode(e.matches ? 'dark' : 'light');
      }
    };
    mql.addEventListener('change', handleChange);
    return () => mql.removeEventListener('change', handleChange);
  }, []);

  const toggleMode = useCallback(() => {
    setMode((prev) => {
      const next = prev === 'dark' ? 'light' : 'dark';
      window.localStorage.setItem(STORAGE_KEY, next);
      return next;
    });
  }, []);

  const value = useMemo(() => ({ mode, toggleMode }), [mode, toggleMode]);

  return <ThemeModeContext.Provider value={value}>{children}</ThemeModeContext.Provider>;
}
